// extracted by mini-css-extract-plugin
export default {"paper":"paper--SwPAm"};